export const wordMarker = (text: string, wordToMark: string) => {
  return text.replaceAll(wordToMark, `<strong>${wordToMark}</strong>`);
};
